import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import type { Asset, Entry } from 'contentful';
import { theme } from '@sg/garnish';

import { useContentfulContentTypeEntry } from '@order/Contentful';

/**
 * Returns the contentful data for the bag.
 */
export const useGiftCardContent = () => {
  const { formatMessage } = useIntl();
  const contentfulResponse = useContentfulContentTypeEntry<GiftCardsScreen>({
    contentType: 'giftCardsScreen',
  });

  return useMemo(() => {
    const contentfulData = contentfulResponse.data?.fields;
    const header = contentfulData?.giftCardAccountCta?.fields;

    return {
      isFetchingContent: contentfulResponse.fetching,
      headerTitle: header?.title ?? formatMessage(messages.headerTitle),
      headerImage: header?.image?.fields?.file?.url,
      headerImageA11y: header?.image?.fields?.description,
      headerTextColor: header?.textColor ?? theme.colors.KALE,
      headerBackgroundColor: header?.backgroundColor ?? theme.colors.OPACITY.KALE.LIGHTEST, // prettier-ignore
    };
  }, [contentfulResponse.data, contentfulResponse.fetching, formatMessage]);
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  headerTitle: {
    defaultMessage: 'Gift the gift of green. Buy a gift card.',
    description: 'Gift Cards Screen | Fallbacks | Header Title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardsScreen = {
  giftCardAccountCta: Entry<{
    title: string;
    textColor: string;
    backgroundColor: string;
    image: Asset;
  }>;
};
